export const formatData = (data: any[], numColumns: number) => {
  const amountFullRows = Math.floor(data.length / numColumns);
  let amountItemsLastRow = data.length - amountFullRows * numColumns;

  while (amountItemsLastRow !== numColumns && amountItemsLastRow !== 0) {
    data.push({ key: `empty-${amountItemsLastRow}`, empty: true });
    amountItemsLastRow++;
  }
  return data;
};

export const groupItemsInRows = (data: any[], itemsPerRow: number) => {
  const rows = [];
  for (let i = 0; i < data.length; i += itemsPerRow) {
    const rowItems = data.slice(i, i + itemsPerRow);
    rows.push(rowItems);
  }
  return rows;
};
